module.exports = __webpack_public_path__ + "static/media/new_patient.f6dc5885.png";